import React, { Fragment } from "react";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { CuratedProductsLinkSerializer } from "web/types/serializers";
import styles from "./curated-products-card.module.css";

interface CuratedProductsCardProps {
    links: CuratedProductsLinkSerializer[];
}

export default function CuratedProductsCard({ links = [] }: CuratedProductsCardProps): JSX.Element {
    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <h4 className={styles.heading}>
                    {gettext("feed.curated_products.looking_for_something.title")}
                </h4>
            </div>
            <div className={styles.flex}>
                {links.map(({ image, url, title }, i) => (
                    <Fragment key={url}>
                        <div className={styles.item}>
                            <a
                                className={styles.itemLink}
                                href={url}
                                onClick={(): void => {
                                    analytics.event("uf_infeed_cta", "click", title);
                                }}
                            >
                                <img
                                    className={styles.itemImage}
                                    src={image}
                                    height={250}
                                    width={200}
                                />
                                <h5 className={styles.itemHeader}>{title}</h5>
                            </a>
                        </div>
                        {i % 2 === 0 ? <div className={styles.keyLine} /> : null}
                    </Fragment>
                ))}
            </div>
        </div>
    );
}
